/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs, { Dayjs } from "dayjs";
import { DurationType } from "~/models";

function checkStartsDate(
  durationType: string,
  starts: Dayjs | null,
  signed: Dayjs | null
) {
  const isValidate = (): string | undefined => {
    if (!starts) {
      return "Starts date is required";
    }
    if (starts && signed && dayjs(starts).isBefore(dayjs(signed))) {
      return "The starts date cannot be before the signed date";
    }

    return undefined;
  };

  return { isValidate: isValidate() };
}

// eslint-disable-next-line max-params
function checkEndsDate(
  durationType: string,
  starts: Dayjs | null,
  signed: Dayjs | null,
  ends: Dayjs | null
) {
  const isValidate = (): string | undefined => {
    if (durationType === DurationType.FIXED && !ends) {
      return "Ends date is required";
    }

    if (
      durationType === DurationType.FIXED &&
      ends &&
      starts &&
      dayjs(ends).isBefore(dayjs(starts))
    ) {
      return "The ends date cannot be before the starts date";
    }

    if (
      durationType === DurationType.FIXED &&
      ends &&
      signed &&
      dayjs(ends).isBefore(dayjs(signed))
    ) {
      return "The ends date cannot be before the signed date";
    }

    return undefined;
  };

  return { isValidate: isValidate() };
}

function checkSignedDate(durationType: string, signed: Dayjs | null) {
  const isValidate = (): string | undefined => {
    if (!signed) {
      return "Signed date is required";
    }

    return undefined;
  };

  return { isValidate: isValidate() };
}

export { checkStartsDate, checkEndsDate, checkSignedDate };
